import React from "react";
import { connect } from "react-redux";
import { Popup, Button } from "devextreme-react";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import { openCloseNotifCotizaciones, showHideFormCotizaciones } from "./actions";
import { paths } from "../../../../../config/routes";
import { push } from "connected-react-router";

class ModalNotif extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      roleType: 1,
      permissions: null,
    };
  }

  handleCerrar = async () => {
    this.props.dispatch(openCloseNotifCotizaciones(false))
    await new Promise(r => setTimeout(r, 500));
    this.props.dispatch(showHideFormCotizaciones(false))
    await new Promise(r => setTimeout(r, 500));
    this.props.dispatch(push(paths.root))
  }

  render() {
    return (
      <Popup
      visible={this.props.isOpenModalNotifCotizaciones}
      showTitle
      height={300}
      width={500}
      dragEnabled={false}
      onHiding={this.handleCerrar}
      closeOnOutsideClick
      title={`Gracias por tu declaración`}
      contentRender={() => (
        <>
        <div className="row" style={{ padding: 10, fontSize: "18px" }}>
          {this.props.isLoading && <LoadingOverlay />}
          Se envió un comprobante de la declaración al correo electrónico del representante legal de la empresa, junto a los datos bancarios para realizar el pago. Cualquier consulta no dudes en comunicarte con nuestro Contact Center al 600 600 22 47
        </div>
        <br/>
        <div className="BtnCloseAlign">
            <Button
              style={{
                borderRadius: "5px",
                background: "#EEEEEE",
                height: "30px"
              }}
              onClick={this.handleCerrar}
            >
              Volver al Inicio
            </Button>
          </div>
        </>
      )}
    />
    );
  }
}

const mapStateToProps = (state) => ({
  isOpenModalNotifCotizaciones: state.cotizaciones.isOpenModalNotifCotizaciones,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalNotif);
